import React from 'react';
import Url from '@core/scripts/helper/url';
import {Button, Grid, Icon, Link, Typography} from '@bonprix/design-system';
import RecommendationSliderDeSy from '@personalization/scripts/components/RecommendationSliderDeSy.jsx';

export default function CartEmpty({texts, hideLoginHint, recoParams}) {

    const max_width = 1000;

    const onClickBackButton = () => {
        window.open(Url.toAbsolute('/'), '_self');
    };

    function LoginHint({texts}) {
        return (
            <div className="flex flex-col items-center gap-1">
                <Typography component='span'>{texts.cot_cart_empty_missing_hint}</Typography>
                <Link
                    arrowPosition="right"
                    href={Url.toAbsolute('/buy/login/?checkout')}
                    showArrow>
                    {texts.cot_cart_empty_login_text}
                </Link>
            </div>
        );
    }

    return (
        <>
            <div className="mx-4">
                <Grid >
                    <Grid.Item s={12} className="flex flex-col items-center gap-3">
                        <div className="flex flex-col items-center gap-1">
                            <Icon className="w-8 h-8" variant="cart" />
                            <Typography>{texts.cot_cart_empty_article_count}</Typography>
                        </div>
                        <Typography variant='bonprix-h4' component='p' align='center'>{texts.mobile_wk_basket_empty}</Typography>
                        {!hideLoginHint && <LoginHint texts={texts} />}
                    </Grid.Item>
                    <Grid.Item s={12} className="mt-8">
                        <RecommendationSliderDeSy
                            dataUrl={recoParams.dataUrl}
                            paramString=""
                            productCardTexts={recoParams.recoTexts}
                            max_width={max_width}
                        ></RecommendationSliderDeSy>

                    </Grid.Item>

                    <Grid.Item s={2}></Grid.Item>
                    <Grid.Item s={8}>
                        <Button
                            icon="arrow-left"
                            variant="secondary"
                            onClick={onClickBackButton}
                        >
                            {texts.cot09_wk_continue_shopping_with_bonprix}
                        </Button>
                    </Grid.Item>
                    <Grid.Item s={2}></Grid.Item>

                </Grid>
            </div>
        </>
    );
}
